import { createSelector } from "@ngrx/store";
import { ImportBase } from "./import.service";
import { ImportField, ImportState, FileParsingError } from "./import.states";

export const isLoadedSelector = createSelector(
    (state:ImportState) => state.isLoaded,
    (loaded:boolean) => loaded
);

export const isImportDialogOpenSelector = createSelector(
    (state:ImportState) => state.isImportDialogOpen,
    (isImportDialogOpen:boolean) => isImportDialogOpen
);

export const importedFieldsSelector = createSelector(
    (state:ImportState) => state.importedFields,
    (importedFields:ImportField[]) => importedFields
);

export const selectedImportedFieldsSelector = createSelector(
    importedFieldsSelector,
    (importedFields:ImportField[]) => importedFields.filter((field) => field.selected)
);

export const importHandlerSelector = createSelector(
    (state: ImportState) => state.importHandler,
    (importHandler: ImportBase) => importHandler
);

export const fileParsingErrorsSelector = createSelector(
    (state: ImportState) => state.fileParsingErrors,
    (fileParsingErrors: FileParsingError[]) => fileParsingErrors
);

export const hasErrorsSelector = createSelector(
    (state: ImportState) => state.fileParsingErrors,
    (state: ImportState) => state.importedFields,
    (parsingErrors: FileParsingError[], importedFields: ImportField[]) => {
        return parsingErrors.length > 0 || importedFields.some(f => f.hasError);
    }
);